import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';

export function priceOutsideOfOptionRangeBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Configuration likely won't result in selectable option. User min/max:{' '}
        {parsedStatusObj.maxPrice && parsedStatusObj.minPrice
          ? '$' +
            ApplyRounding(Number(parsedStatusObj.minPrice), 2) +
            '/' +
            '$' +
            ApplyRounding(Number(parsedStatusObj.maxPrice), 2)
          : 'unknown'}
        . Largest option price:{' '}
        {parsedStatusObj.optionPrice
          ? '$' + ApplyRounding(Number(parsedStatusObj.optionPrice), 2)
          : 'unknown'}
        .
      </Body3>
    </td>
  );
}
